// extracted by mini-css-extract-plugin
module.exports = {"header":"ChangeLog-module__header___3Jh2P","table":"ChangeLog-module__table___glHGi"};